import React, { useEffect, useState } from "react";
import SummaryApi from "../common/index";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import { MdModeEdit } from "react-icons/md";
import { FaEnvelope, FaUserShield, FaCalendarAlt } from "react-icons/fa";
import ChangeUserRole from "../components/ChangeUserRole";
import Loading from "../loading";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";

const AllUsers = () => {
  const [allUser, setAllUsers] = useState([]);
  const [openUpdateRole, setOpenUpdateRole] = useState(false);
  const [updateUserDetails, setUpdateUserDetails] = useState({
    email: "",
    name: "",
    role: "",
    _id: "",
    imageUrl: "",
  });
  const [loading, setLoading] = useState(true);

  const fetchAllUsers = async () => {
    try {
      const fetchData = await fetch(SummaryApi.allUser.url, {
        method: SummaryApi.allUser.method,
        credentials: "include",
      });

      const dataResponse = await fetchData.json();
      if (dataResponse.success) {
        setAllUsers(dataResponse.data);
      } else {
        toast.error(dataResponse.message, {
          style: {
            background: "#f39c12",
            color: "white",
          },
          autoClose: 3000,
          closeOnClick: true,
        });
      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.", {
        style: {
          background: "#f39c12",
          color: "white",
        },
        autoClose: 3000,
        closeOnClick: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="container mx-auto p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
        {allUser.map((el) => (
          <div
            key={el._id}
            className="bg-gray-900 text-white p-5 rounded-xl shadow-lg flex flex-col items-start transition-transform transform hover:scale-105 w-full max-w-md mx-auto"
          >
            <div className="flex items-center mb-4">
              <div className="rounded-full p-1 bg-gray-800 w-14 h-14 flex items-center justify-center overflow-hidden">
                <img
                  src={
                    el.profilePic?.startsWith("http")
                      ? el.profilePic
                      : `https://dates-website-backend.vercel.app/${el.profilePic}`
                  }
                  alt={el?.name || "User"}
                  className="w-full h-full object-cover rounded-full border-2 border-blue-200"
                />
              </div>

              <div className="ml-4">
                <h2
                  className="text-lg font-semibold"
                  style={{ color: "#f39c12" }}
                >
                  {el.name}
                </h2>
                <p className="text-gray-300 flex items-center">
                  <FaEnvelope className="mr-2" />
                  {el.email}
                </p>
                <p className="text-gray-400 flex items-center">
                  <FaUserShield className="mr-2" />
                  {el.role}
                </p>
                <p className="text-gray-500 text-sm flex items-center">
                  <FaCalendarAlt className="mr-2" />
                  Created on: {moment(el.createdAt).format("LL")}
                </p>
              </div>
            </div>

            <button
              className="bg-[#f39c12] hover:bg-orange-600 p-2 rounded-full flex items-center transition-colors"
              onClick={() => {
                setUpdateUserDetails(el);
                setOpenUpdateRole(true);
              }}
            >
              <MdModeEdit className="mr-2" />
              Edit Role
            </button>
          </div>
        ))}
      </div>

      {openUpdateRole && (
        <ChangeUserRole
          onClose={() => setOpenUpdateRole(false)}
          name={updateUserDetails.name}
          email={updateUserDetails.email}
          role={updateUserDetails.role}
          userId={updateUserDetails._id}
          imageUrl={updateUserDetails.imageUrl}
          callFunc={fetchAllUsers}
        />
      )}

      <ToastContainer />
    </div>
  );
};

export default AllUsers;
